import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_MIDIA_PAGA: MapaCargo = 
{
  id: 'analista-de-midia-paga',
  titulo: 'Analista de Mídia Paga',
  setor: 'Performance',
  secoes: [
    {
      id: 'desenvolver-estrategias-de-segmentacao',
      titulo: 'Desenvolver estratégias de segmentação',
      atividades: [
        'Criar públicos-alvo detalhados com base em dados demográficos, comportamentais e psicográficos.',
        'Analisar dados históricos para refinar a segmentação e maximizar a performance.',
      ],
    },
    {
      id: 'gestao-de-orcamento-e-alocacao-de-recursos',
      titulo: 'Gestão de orçamento e alocação de recursos',
      atividades: [
        'Controlar e redistribuir o orçamento de campanhas com base em direcionamento prévio',
        'Definir prioridades de investimento entre canais e campanhas para maximizar o ROI.',
      ],
    },
    {
      id: 'producao-e-otimizacao-de-criativos',
      titulo: 'Produção e otimização de criativos',
      atividades: [
        'Colaborar com a equipe de criação para desenvolver anúncios impactantes e adaptados para diferentes formatos e plataformas.',
        'Garantir que os criativos estejam alinhados com os objetivos de campanha e a jornada do consumidor.',
      ],
    },
    {
      id: 'automacao-de-marketing-e-remarketing',
      titulo: 'Automação de marketing e remarketing',
      atividades: [
        'Configurar e gerenciar fluxos de automação de anúncios e campanhas de remarketing dinâmico.',
        'Identificar oportunidades para reconquistar leads e clientes utilizando listas de remarketing.',
      ],
    },
    {
      id: 'analise-de-atribuicao',
      titulo: 'Análise de atribuição',
      atividades: [
        'Utilizar modelos de atribuição para compreender o impacto de cada canal no funil de vendas.',
      ],
    },
    {
      id: 'relatorios-e-dashboards-personalizados',
      titulo: 'Relatórios e dashboards personalizados',
      atividades: [
        'Criar relatórios detalhados e dashboards em ferramentas como Google Data Studio ou Power BI.',
        'Apresentar insights para stakeholders com recomendações claras para melhorias.',
      ],
    },
    {
      id: 'configuracao-e-manutencao-de-pixels-e-tags',
      titulo: 'Configuração e manutenção de pixels e tags',
      atividades: [
        'Gerenciar a implementação e monitoramento de pixels de rastreamento (Facebook Pixel, Google Tag Manager, etc.).',
        'Garantir que todas as tags estejam funcionando corretamente para coletar dados precisos.',
      ],
    },
    {
      id: 'treinamento-e-capacitacao',
      titulo: 'Treinamento e capacitação',
      atividades: [
        'Treinar membros da equipe ou clientes sobre boas práticas em mídia paga e uso de ferramentas.',
        'Compartilhar aprendizados de campanhas anteriores para otimizar futuras ações.',
      ],
    },
    {
      id: 'gestao-de-crises-e-ajustes-rapidos',
      titulo: 'Gestão de crises e ajustes rápidos',
      atividades: [
        'Monitorar campanhas em tempo real para identificar problemas (ex.. anúncios reprovados ou queda de desempenho) e reagir rapidamente.',
        'Criar planos de contingência para situações de orçamento ou estratégia.',
      ],
    },
    {
      id: 'integracao-com-times-de-vendas-e-marketing',
      titulo: 'Integração com times de vendas e marketing',
      atividades: [
        'Colaborar com equipes de vendas para alinhar estratégias de geração de leads.',
        'Garantir que as campanhas de mídia estejam conectadas com as metas gerais de marketing.',
      ],
    },
    {
      id: 'atendimento-ao-cliente',
      titulo: 'Atendimento ao cliente',
      atividades: [
        'Servir de ponto de contato entre clientes e a equipe da agência.',
        'Reunir feedbacks e acompanhar aprovações e revisões.',
      ],
    },
  ],
}
